import React from 'react'

import Icon, { Props } from './Icon'

const IconClose: React.FC<Props> = (props) => {
  return (
    <Icon title="" viewBox="0 0 18.385 18.385" {...props}>
      <path transform="rotate(-45.001 9.192 9.193)" d="M7.193-1.808h4v22h-4z" />
      <path
        transform="rotate(-45.001 9.192 9.193)"
        d="M-1.808 7.193h22v4h-22z"
      />
    </Icon>
  )
}

export default IconClose
